import { render } from "./SettingsAPI.vue?vue&type=template&id=e6a53b42&ts=true"
import script from "./SettingsAPI.vue?vue&type=script&lang=ts"
export * from "./SettingsAPI.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__